import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import WarehouseActions from "./components/WarehouseActions/WarehouseActions";
import WarehouseTable from "./components/WarehouseTable/WarehouseTable";

const WAREHOUSE_PAGE_TITLE = "Quản lý Nhà kho";

const WarehouseWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: WAREHOUSE_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <WarehouseActions handleSearch={handleSearch} params={params} />
          <WarehouseTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default WarehouseWebLayout;
